export default (elem, opts = { preventScroll: true }) =>
  elem && elem.focus(opts);
